module.exports = __webpack_public_path__ + "img/saveimg.1f0ffc35.png";